import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { ExclamationCircleIcon } from "@octopusdeploy/design-system-icons";
import { space, themeTokens, text } from "@octopusdeploy/design-system-tokens";
import React from "react";
const style = css({
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    gap: space[4],
});
const labelStyle = css({
    font: text.body.regular.medium,
});
type MissingSourceNameWarningProps = {
    showHelpLink: boolean;
};
export const MissingSourceNameWarning = (props: MissingSourceNameWarningProps) => {
    const { showHelpLink } = props;
    return (<span className={style}>
            <ExclamationCircleIcon size={"font-size"} color={themeTokens.color.icon.warning}/>
            <span className={labelStyle}>Missing source name</span>
            {showHelpLink && (<ExternalLink size={"small"} href={"argo-cd-multi-source-naming"}>
                    Learn more
                </ExternalLink>)}
        </span>);
};
